module.exports = __webpack_public_path__ + "media/images/bsmart/icons/player_exe_commento-530b7fbfb5cb31575b043265bc0235a2.svg";